import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { CatalogCostAccessGate } from '~/features/catalog-v2/components/catalog-cost-access-gate';
import { HISTORY_STATUSES } from '~/features/cost-estimate/utils/cost-approvals-search';

const CostApprovalsPage = lazy(() => import('~/features/catalog-v2/pages/cost-approvals-page'));

/** History status filter and 1-based page in the URL; a bad value opens the default view. */
const costApprovalsSearchSchema = z.object({
  status: z.enum(HISTORY_STATUSES).optional().catch(undefined),
  page: z.number().int().min(1).optional().catch(undefined),
});

/** Cost approvals on catalog-service (§95): what waits for a decision, and every decision made.
 *  Amounts: `CatalogCostAccessGate` lets in lily.ai users and catalog-service's approvers. */
export const Route = createFileRoute('/_authenticated/_tenant/catalog-v2/cost-approvals')({
  validateSearch: costApprovalsSearchSchema,
  component: () => (
    <CatalogCostAccessGate>
      <Suspense fallback={<PageSkeleton />}>
        <CostApprovalsPage />
      </Suspense>
    </CatalogCostAccessGate>
  ),
});
